module.exports = __webpack_public_path__ + "static/img/11.c7fbc0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/11.png
// module id = Hajv
// module chunks = 0